import { SearchTerm } from "./SearchTerm";

const DoorSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "locName",
        translationKey: "name"
    },
    {
        heading: "Zones",
        accessor: "zones",
        searchOnName: "zoneByZoneId.zoneName",
        translationKey: "zones"
    },
    {
        heading: "Master Controllers",
        accessor: "controller",
        searchOnName: "zoneByZoneId.controller.deviceImprox.devName",
        translationKey: "masterControllers"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "zoneByZoneId.controller.site.siteName",
        translationKey: "site"
    }
];

export default DoorSearch;
